import React from 'react';
import classNames from 'classnames/bind';

import { Skeleton } from 'components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const SkeletonHeadingControls = () => (
  <div className={cx('button-wrapper')}>
    {Array.from(
      Array(2).keys(),
    ).map((skeleton) => (
      <Skeleton
        key={skeleton}
        className={cx('button')}
      />
    ))}
  </div>
);
